import axios from 'axios'

export default () => {
  return axios.create({
    // baseURL: 'https://utility.fishionaire.nl'
    // baseURL: 'https://localhost:3000/api'
    baseURL: 'https://mps.fishionaire.nl/api'
  })
}
